import { AccountVerifyPhoneContainer } from 'src/containers';
export const AccountVerifyPhone = () => <AccountVerifyPhoneContainer />;
